import { isImmutable, fromJS } from 'immutable';

export default function recursiveToJs(object) {
  if (isImmutable(object)) {
    return object.toJS();
  }

  return fromJS(object).toJS();
}
